'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Override = function Override(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 15 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'override icon'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M14 8v1.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5V8zm-.5-8h-12C.673 0 0 .673 0 1.5v8c0 .827.673 1.5 1.5 1.5H7v2H5v1h5v-1H8v-2h5.5c.827 0 1.5-.673 1.5-1.5v-8c0-.827-.673-1.5-1.5-1.5z',
          fill: 'currentColor' }),
        _react2.default.createElement('path', { stroke: 'currentColor', d: 'M5 5.5L7 8l4-5' })
      )
    )
  );
};
/*eslint-enable */

exports.default = Override;
//# sourceMappingURL=Override.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Override.js